// eslint-disable-next-line
export const emailRegexp = /^([A-Za-z0-9])+([-_]*[A-Za-z0-9]+)*(\.[A-Za-z0-9]+([-_]*[A-Za-z0-9]+)*)*@([A-Za-z0-9])+([-_]*[A-Za-z0-9]+)*(\.[A-Za-z0-9]+([-_]*[A-Za-z0-9]+)*)*(\.[a-zA-Z]{2,4})$/
